import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as DisplayMode from 'constants/DisplayMode';

import {expandAllMatches,
    expandAllGroups} from 'actions/creators/Expand';
import {collapseAllMatches,
    collapseAllGroups} from 'actions/creators/Collapse';
import {showLineNumbers, hideLineNumbers} from 'actions/creators/Line';

import {setDisplayMode as setDisplayModeAction} from 'actions/creators/SetDisplayMode';

import {toggleMatchPrematch as toggleMatchPrematchAction,
    toggleMatchLive as toggleMatchLiveAction} from 'actions/creators/UserSelection';

import Grid from './components/Grid.jsx';

function fetchDisplayMode(props) {
    const defaultDisplayMode = {type: DisplayMode.ALL};

    if (props.gridSelection === undefined || !props.gridSelection) {
        return defaultDisplayMode;
    }

    let newDisplayMode;
    const section = props.section;
    const displayModeAttr = props.gridSelection.getIn([section, 'lastShown']);

    if (!displayModeAttr) {
        newDisplayMode = defaultDisplayMode;
    } else {
        if (displayModeAttr.has('sportId')) {
            newDisplayMode = {type: DisplayMode.SPORT, id: displayModeAttr.get('sportId')};
        }

        if (displayModeAttr.has('leagueId')) {
            newDisplayMode = {type: DisplayMode.LEAGUE, id: displayModeAttr.get('leagueId')};
        }
    }

    return newDisplayMode;
}

class LocalizedGrid extends React.Component {
    static propTypes = {
        section: PropTypes.string.isRequired,
        languageId: React.PropTypes.number.isRequired,
        displayMode: React.PropTypes.object.isRequired,
        matchId: PropTypes.any,
        gridSelection: React.PropTypes.object.isRequired,
        gridLocalization: React.PropTypes.object.isRequired,
        setDisplayModeAction: React.PropTypes.func.isRequired,
        toggleMatchLiveAction: React.PropTypes.func.isRequired,
        toggleMatchPrematchAction: React.PropTypes.func.isRequired,
        expandAllMatches: React.PropTypes.func.isRequired,
        expandAllGroups: React.PropTypes.func.isRequired,
        collapseAllMatches: React.PropTypes.func.isRequired,
        collapseAllGroups: React.PropTypes.func.isRequired,
        showLineNumbers: React.PropTypes.func.isRequired,
        hideLineNumbers: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const {displayMode} = this.props;

        if (displayMode.type == DisplayMode.TIMETABLE) {
            this.props.setDisplayModeAction(fetchDisplayMode(this.props));
        }
    }

    render() {
        const {section, matchId, gridSelection, gridLocalization, sportId} = this.props;

        const expandAllMatchesAction = this.props.expandAllMatches;
        const expandAllGroupsAction = this.props.expandAllGroups;
        const collapseAllMatchesAction = this.props.collapseAllMatches;
        const collapseAllGroupsAction = this.props.collapseAllGroups;
        const showLineNumbersAction = this.props.showLineNumbers;
        const hideLineNumbersAction = this.props.hideLineNumbers;
        const toggleMatchLiveAction = this.props.toggleMatchLiveAction;
        const toggleMatchPrematchAction = this.props.toggleMatchPrematchAction;

        const selectionToggleMatchAction = (section === 'live' ? toggleMatchLiveAction : toggleMatchPrematchAction);
        const gridSelectionSection = (section === 'live' ? gridSelection.get('live') : gridSelection.get('preMatch'));

        return (
            <Grid section={section}
                  gridLocalization={gridLocalization}
                  expandAllMatchesAction={expandAllMatchesAction}
                  expandAllGroupsAction={expandAllGroupsAction}
                  collapseAllMatchesAction={collapseAllMatchesAction}
                  collapseAllGroupsAction={collapseAllGroupsAction}
                  showLineNumbersAction={showLineNumbersAction}
                  hideLineNumbersAction={hideLineNumbersAction}
                  selectionToggleMatchAction={selectionToggleMatchAction}
                  gridSelection={gridSelectionSection}
                  matchId={matchId}
                  currentPage={this.props.currentPage}
                  perPage={this.props.perPage}
                  changeFilter={this.props.changeFilter}
                  sportId={sportId}
            />
        );
    }
}

function select(state, props) {
    return {
        ...props,
        languageId: state.application.get('languageId'),
        displayMode: state.application.get('displayMode'),
        gridSelection: state.application.get('userGridSelection')
    };
}

export default connect(select, {
    setDisplayModeAction,
    toggleMatchLiveAction,
    toggleMatchPrematchAction,
    expandAllMatches,
    expandAllGroups,
    collapseAllMatches,
    collapseAllGroups,
    showLineNumbers,
    hideLineNumbers
})(LocalizedGrid);


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/index.js